import { CadastroInvestidorRequest, TipoRepresentanteLegal, InvestidorResponse } from 'common/genericTypes';
import moment from 'moment';
import { InvestidorState } from 'store/modules/investidores/registro';
import { addCpfCnpjMask } from 'utils/mask';
import { stripCpfCnpjFormatting } from 'utils/validation';

export default class InvestidorParser {
  static stateToCadastroInvestidorRequest(investidor: InvestidorState): CadastroInvestidorRequest {
    return {
      cpfCnpj: stripCpfCnpjFormatting(investidor.informacoesPrincipais.cpfCnpj),
      razaoSocial: investidor.informacoesPrincipais.razaoSocial,
      nacionalidade: investidor.informacoesPrincipais.nacionalidade,
      cep: investidor.endereco.cep.replace(/\D/g, ''),
      logradouro: investidor.endereco.logradouro,
      numero: investidor.endereco.numero,
      complemento: investidor.endereco.complemento,
      bairro: investidor.endereco.bairro,
      cidade: investidor.endereco.cidade,
      uf: investidor.endereco.uf,
      profissaoAtividadePrincipal: investidor.informacoesPrincipais.profissao,
      email: investidor.informacoesParaContato.email,
      telefones: investidor.informacoesParaContato.telefones.map((_) => _.replace(/\D/g, '').slice(0, 11)),
      investidorPoliticamenteExposto: investidor.informacoesPrincipais.investidorPoliticamenteExposto,
      dataNascimento: investidor.informacoesPrincipais.dataNascimento
        ? moment(investidor.informacoesPrincipais.dataNascimento).toDate()
        : undefined,
      tipo: investidor.informacoesPrincipais.tipo,
      vinculadoCustodiante: investidor.informacoesPrincipais.vinculadoCustodiante,
      representantesLegais: investidor.representantesLegais.map((rep) => ({
        nome: rep.nome,
        cpf: rep.cpf.replace(/\D/g, ''),
        tipo: TipoRepresentanteLegal.RepresentanteLegal,
      })),
      rendaMensalDeclarada: investidor.informacoesPrincipais.rendaMensalDeclarada,
      patrimonioDeclarado: investidor.informacoesPrincipais.patrimonioDeclarado,
      banco: investidor.informacoesBancarias.banco,
      ispbBanco: investidor.informacoesBancarias.ispbBanco,
      agencia: investidor.informacoesBancarias.agencia,
      agenciaDigito: investidor.informacoesBancarias.agenciaDigito,
      conta: investidor.informacoesBancarias.conta,
      contaDigito: investidor.informacoesBancarias.contaDigito,
    };
  }

  static apiResponseToInvestidorState(response: InvestidorResponse): InvestidorState {
    return {
      id: response.id,
      informacoesPrincipais: {
        cpfCnpj: response.cpfCnpj,
        isPj: response.cpfCnpj.length > 11,
        razaoSocial: response.razaoSocial,
        profissao: response.profissaoAtividadePrincipal,
        cnaePrincipal: response.cnaePrincipal,
        nacionalidade: response.nacionalidade,
        dataNascimento: response.dataNascimento,
        investidorPoliticamenteExposto: response.investidorPoliticamenteExposto,
        vinculadoCustodiante: response.vinculadoCustodiante,
        tipo: response.tipo,
        rendaMensalDeclarada: response.rendaMensalDeclarada,
        patrimonioDeclarado: response.patrimonioDeclarado,
      },
      endereco: {
        cep: response.cep,
        logradouro: response.logradouro,
        numero: response.numero || '',
        complemento: response.complemento || '',
        bairro: response.bairro,
        cidade: response.cidade,
        uf: response.uf,
      },
      informacoesParaContato: {
        telefones: response.telefones,
        email: response.email,
      },
      informacoesBancarias: {
        banco: response.razaoSocialBanco || '',
        ispbBanco: response.ispbBanco || '',
        agencia: response.agenciaBanco || '',
        agenciaDigito: response.agenciaDigitoBanco || '',
        conta: response.contaBanco || '',
        contaDigito: response.contaDigitoBanco || '',
      },
      representantesLegais: response.representantesLegais.map((_) => ({
        nome: _.nome,
        cpf: addCpfCnpjMask(_.cpf),
      })),
      documentos: response.documentos.map((_) => ({ type: _.investidorDocumentType, remoteFileInfo: _ })),
      documentosExcluir: [],
      highlightErrors: false,
    };
  }
}
